import { StoryHotNewSection } from './StoryHotNewSection'
import { withStoryHotNewSection } from './withStoryHotNewSection'

const ConnectedStoryHotNewSection = withStoryHotNewSection(StoryHotNewSection)
export { ConnectedStoryHotNewSection as StoryHotNewSection }
